import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import Dict from "../../helper/dict";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";


const TABLE_HEAD = ["#", "رشته", "گرایش", "توضیحات", "نوع سرویس", "کد تخفیف", "درصد تخفیف", "سقف تخفیف", "وضعیت", "عملیات"];

export function AgentBranchDiscountGrid({
                                          AgentBranchDiscounts,
                                          setModalOpen,
                                          setSelectedRow,
                                        }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "توضیحات": "description",
    "نوع سرویس": "consultation_commission",
    "کد تخفیف": "consultation_vat_percentage",
    "درصد تخفیف": "service_commission",
    "سقف تخفیف": "service_vat_percentage",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "رشته": true,
    "گرایش": true,
    "توضیحات": true,
    "نوع سرویس": true,
    "کد تخفیف": true,
    "درصد تخفیف": true,
    "سقف تخفیف": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {AgentBranchDiscounts.map(
          ({id, field_title, branch_title, description, type, code, percentage, value, status, branch_id}, index) => {
            const isLast = index === AgentBranchDiscounts.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={branch_id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip className="textRight" variant="ghost"
                          value={Dict(type)}
                          color={type === "consultation" ? "teal" : type === "service" ? "indigo" : "red"}/>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {code}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {percentage && persianNumberFormat(percentage) + "%"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {value && persianNumberFormat(value, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="عملیات">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(AgentBranchDiscounts[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}